export const nowIso = () => new Date().toISOString();
/**
 * Format an ISO date for display, e.g. "25 sept. 2026, 14:32"
 * @param {string} iso - ISO date string
 * @param {string} [locale] - Language code used for formatting (defaults to the browser locale)
 * @returns {string} Formatted date, or "" if the date is missing or invalid
 */
export const formatDateTime = (iso, locale) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(date);
};
